module.exports = __webpack_public_path__ + "media/Megazone.092c6054.mp4";